module.exports = __webpack_public_path__ + "img/email.75261ef5.svg";